import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { createAri } from '@atlassian/jira-platform-ari';
import type { useVersionsRefetchQuery$data } from '@atlassian/jira-relay/src/__generated__/useVersionsRefetchQuery.graphql';
import { fromRelayObservable } from '../../common/redux-observable';
import { REFETCH_VERSIONS, setVersions } from '../../state/actions/version';
import { getCloudId, getProjectIds } from '../../state/selectors/app';
import type { Action, ActionsObservable, Dependencies, MiddlewareAPI } from '../../state/types';

export const refetchVersionsEpic = (
	action$: ActionsObservable,
	store: MiddlewareAPI,
	dependencies?: Dependencies,
): Observable<Action> =>
	action$.ofType(REFETCH_VERSIONS).mergeMap(() => {
		const state = store.getState();
		const cloudId = getCloudId(state);
		const projectIds = getProjectIds(state);
		if (!projectIds.length || !dependencies || !dependencies.refetchVersionsForProjects) {
			return Observable.empty();
		}

		const refetchVersions = dependencies.refetchVersionsForProjects;

		const jiraProjectIds = projectIds.map((id) =>
			createAri({
				resourceOwner: 'jira',
				cloudId,
				resourceType: 'project',
				resourceId: String(id),
			}),
		);
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return fromRelayObservable(() => refetchVersions(jiraProjectIds))
			.flatMap((data: useVersionsRefetchQuery$data) => {
				const versions = data?.jira?.versionsForProjects;
				return Observable.of(
					setVersions({
						versions: versions?.edges?.map((edge) => edge?.node?.versionId)?.filter(Boolean) ?? [],
					}),
				);
			})
			.catch((error) =>
				fireErrorAnalytics({
					error,
					meta: {
						id: 'refetchVersionsQuery',
						packageName: 'jiraSoftwareBacklog',
						teamName: 'a4t-tanuki',
					},
				}),
			) as Observable<Action>;
	});
